import CityPage from "../CityPage";

export default function Barrington() {
  return <CityPage slug="barrington" />;
}
